import { AnswerCommand } from 'core/commands/elements/answers/answer.abstract.command';
import { tactileoAnswersDTOTypes } from 'utils/activityItem.util';

export class PaperQuestionAnswerCommand extends AnswerCommand {
  constructor(paperQuestionAnswer) {
    super(tactileoAnswersDTOTypes.PAPER_QUESTION, paperQuestionAnswer);
    // The scan of the paper copy is not provided by the player
    this.scan_file_url = null;
  }
}
